import styled from 'styled-components';

const MotorDriveWrapper = styled.div``;

export { MotorDriveWrapper };
